import React from "react";
import { Typography, Grid, Button, Box } from "@material-ui/core";
import queries from "Shared/queries";
import { useMutation } from "@apollo/client";
import mutations from "Shared/mutations";
import { successToast } from "Modules/DPToast";
import { DPSpacer } from "Components/DP";
import { useEmployeeProfileQuery } from "Hooks/useEmployeeProfileQueryContext";
import { handleValidationErrors } from "Modules/HandleValidationErrors";
import { TerminateUserMutation, TerminateUserMutationVariables } from "generated/graphql";

type OffCyclePaymentFormTerminationDialogProps = {
  onClose: () => void;
};

const OffCyclePaymentFormTerminationDialog = ({
  onClose,
}: OffCyclePaymentFormTerminationDialogProps) => {
  const { userDetails } = useEmployeeProfileQuery();

  const [terminateUserFn] = useMutation<
    TerminateUserMutation,
    TerminateUserMutationVariables
  >(mutations.TERMINATE_USER, {
    variables: { employeeProfileId: userDetails ? userDetails.id : "" },
  });

  const handleSubmit = async () => {
    const refetchQueries = [
      {
        query: queries.GET_EMPLOYEE_PROFILE,
        variables: { employeeProfileId: userDetails!.id },
      },
    ];

    try {
      const result = await terminateUserFn({ refetchQueries });

      if (
        result &&
        result.data &&
        result.data.terminateUser &&
        result.data.terminateUser.deductionAmountCents >= 0
      ) {
        successToast("User has been successfully terminated.");
        onClose();
      }
    } catch (err) {
      handleValidationErrors(err);
    }
  };

  return (
    <Box display="flex" flexDirection="column" padding={4}>
      <Typography>
        Do you want to cancel the user's DailyPay account at this time?
      </Typography>
      <DPSpacer spacing={3} />
      <Typography>
        If you cancel their account, the following will happen immediately:
      </Typography>
      <DPSpacer spacing={2} />
      <ul>
        <li>They will be prevented from making transfers in DailyPay</li>
        <li>Their available balance will stop accruing earnings</li>
      </ul>
      <DPSpacer spacing={2} />
      <Grid container justify="center" spacing={2}>
        <Grid item>
          <Button
            color="primary"
            size="large"
            onClick={handleSubmit}
            variant="contained"
          >
            Cancel Account
          </Button>
        </Grid>
        <Grid item>
          <Button
            color="default"
            onClick={onClose}
            size="large"
            variant="contained"
          >
            Skip
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OffCyclePaymentFormTerminationDialog;
